import React from 'react';
import { CategoryType } from '../../types';
import { PeriodType } from './types';

export type TContextProps = {
  periodType: PeriodType;
  category?: CategoryType;
  isHourly?: boolean;
};

export const CategoryAccordionBodyContext = React.createContext<TContextProps>({
  periodType: 'current',
  isHourly: false,
});
